// месяца, которые нужно сократить
export default {
  ru: {
    // safari не сокращает эти два месяца
    июля: 'июл',
    июня: 'июн',
    сент: 'сен',
    нояб: 'ноя',
    февр: 'фев',
  },
  pl: {
    /*
     * в safari формат short для польского месяца работает как 2-digit,
     * Intl.DateTimeFormat('pl-PL', {day: "numeric", timeZone: "UTC", month: "short"}).format(new Date('Fri Jun 22 1900 02:30:17 GMT+0230 '));
     * выдает 22.06, а не 22 cze
     * поэтому при форматировании польских дат применяем long вместо short,
     * и если был запрошен short - заменяем длинные (склоненные) названия на короткие:
     */
    stycznia: 'sty',
    lutego: 'lut',
    marca: 'mar',
    kwietnia: 'kwi',
    maja: 'maj',
    czerwca: 'cze',
    lipca: 'lip',
    sierpnia: 'sie',
    września: 'wrz',
    października: 'paź',
    listopada: 'lis',
    grudnia: 'gru',
  },
};
